export const REGION_REPORT_ID = 'region';
